var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconWarning = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 144,
    viewBox: "0 0 144 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72 46.5V78",
    stroke: "#FF5858",
    strokeWidth: 10.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M126.481 51.4802V92.52C126.481 99.24 122.881 105.48 117.061 108.9L81.4211 129.48C75.6011 132.84 68.401 132.84 62.521 129.48L26.881 108.9C21.061 105.54 17.4609 99.3 17.4609 92.52V51.4802C17.4609 44.7602 21.061 38.52 26.881 35.1L62.521 14.52C68.341 11.16 75.5411 11.16 81.4211 14.52L117.061 35.1C122.881 38.52 126.481 44.7002 126.481 51.4802Z",
    stroke: "#FF5858",
    strokeWidth: 10.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72 97.1997V97.7997",
    stroke: "#FF5858",
    strokeWidth: 10.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconWarning);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-warning.22b6d6a7645ceeef7ad125eb76e04c38.svg";